import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_IMAGE_STYLE } from './schema';

const MUTATION = gql`
  mutation UpdateImageStyle(
    $id: ID!
    $name: String!
    $resourceIds: [ID!]!
    $imageIndicesToRemove: [Int!]
  ) {
    updateImageStyle(
      id: $id
      name: $name
      customerResourceIds: $resourceIds
      referenceImagesToRemove: $imageIndicesToRemove
    ) {
      ...ImageStyle
    }
  }
  ${FRAGMENT_IMAGE_STYLE}
`;

export const updateImageStyle = async ({ id, name, resourceIds, imageIndicesToRemove }) => {
  const variables = {
    id,
    name,
    resourceIds,
    imageIndicesToRemove,
  };

  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp(result.data);
};
